"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const labelButton_1 = __importDefault(require("../../components/labelButton/labelButton"));
const utils_1 = require("../../utils/utils");
const authSlice_1 = require("./authSlice");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const input_1 = __importStar(require("../../components/input/input"));
const constants_1 = require("../../constants/constants");
const styles_1 = __importDefault(require("../../styles/styles"));
const textStyles_1 = __importDefault(require("../../components/text/textStyles"));
const analytics_1 = require("../../utils/analytics/analytics");
const EstimateLoanImage = require('../../assets/images/At-work-Lendigo.png');
const EstimateLoan = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [email, setEmail] = (0, react_1.useState)('');
    const [monthlyRevenue, setMonthlyRevenue] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        dispatch((0, authSlice_1.resetAuthSlice)());
    }, []);
    // Create temporary account
    const createTemporaryAccount = async () => {
        setIsLoading(true);
        const payload = {
            email: email.toString(),
            monthly_revenue: typeof monthlyRevenue === 'boolean' ? -1 : (0, utils_1.removeCommasNumber)(monthlyRevenue),
        };
        const result = await dispatch((0, authSlice_1.temporaryAccount)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'estimate_loan',
            status: 'submitted',
            location: 'screen_EstimateLoan',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'estimate_loan',
                status: 'success',
                location: 'screen_EstimateLoan',
            });
            setIsLoading(false);
            navigation.navigate(screenConstants_1.CREATE_ACCOUNT_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'estimate_loan',
                status: 'fail',
                location: 'screen_EstimateLoan',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, withLogo: true, image: EstimateLoanImage, titleText: "Apply for a Business Loan", subTitleColor: theme_1.default.colors.COLOR_GRAY_DARK, subTitleText: "Start with an estimate of how much loan you can get for your business." },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_MONEY, label: `${constants_1.NAIRA_SYMBOL} Monthly revenue`, placeholder: `${constants_1.NAIRA_SYMBOL} Monthly revenue`, setValue: setMonthlyRevenue, error: (0, utils_1.getError)('monthly_revenue', errors), value: monthlyRevenue }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Email", placeholder: "Email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: email }),
        react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Get An Estimate", onPress: createTemporaryAccount, eventName: "estimateLoan_seeLoanEstimation" }),
        react_1.default.createElement(labelButton_1.default, { title: "Login", onPress: () => navigation.replace(screenConstants_1.SIGN_IN_SCREEN), disabled: false, textColor: theme_1.default.colors.COLOR_PRIMARY, eventName: "estimateLoan_login", textBeforeLink: "Already have an account? ", positionStyle: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexDirectionRow], linkStyle: textStyles_1.default.underline })));
};
exports.default = EstimateLoan;
